import { Link } from "gatsby"
import Img from "gatsby-image"
import Modal from "react-bootstrap/Modal"
import styled from "styled-components"

const ChineseText = styled.span`
  font-family: "Liu Jian Mao Cao", serif;
`

const VideoModalHeader = styled(Modal.Header)`
  padding: 5px 10px 5px 5px;
  background-color: black;
  border-bottom-color: black;

  .close {
    color: white;
  }
`

const BigA = styled.a.attrs({
  className: "",
})`
  font-size: 2rem;
`

export const BigLink = styled(Link).attrs({
  className: "",
})`
  font-size: 2rem;
`

export { ChineseText, VideoModalHeader, BigA }

export const BackgroundImg = styled(Img).attrs({
  className: "",
})`
  // object-fit: contain;
  // object-position: 50% 50%;
`
